import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import { Col, Input, Row, Table } from "reactstrap";
import Select from "react-select";
import swal from "sweetalert";
import Swal from "sweetalert2";
import "../../../../css/settings.scss";
import { logout } from "../../../../store/actions/AuthActions";
import { api } from "../../../../utils/api";
import { translate } from "../../../../utils/translate";
import LoadingV3 from "../../../components/Loading/LoadingV3";
import { shownItem } from "../../../../utils/config";
import customSelectStyles from "../../SelectStyle";
import { useHistory } from "react-router-dom";
import NotFound from "../../Common/NotFound";

const statusList = [
    { value: 'Active', label: 'Active' },
    { value: 'Deleted', label: 'Deleted' },
]

const AdminList = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [productPerpage, setProductPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [status, setStatus] = useState('Active');
    const [username, setUsername] = useState('');
    const [firstLoad, setFirstLoad] = useState(true);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getAdminList(event.selected + 1);
    }

    useEffect(() => {
        getAdminList();
        setFirstLoad(false);
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            setPageNumber(1);
            getAdminList(1);
        }
    }, [username, productPerpage, status]);

    const switchStatus = (item) => {
        let message = '';
        if (item.status.toLowerCase() === 'active') {
            message = translate(props.lang, 'Do you want to deactivate this admin?')
        } else {
            message = translate(props.lang, 'Do you want to activate this admin?')
        }
        Swal.fire({
            title: translate(props.lang, `Attention`),
            text: message,
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#A4B6E1",
            confirmButtonColor: "#194BFB",
            confirmButtonText: translate(props.lang, 'Ok'), // Add the translation for 'OK' here
            cancelButtonText: translate(props.lang, 'Cancel'), // Add the translation for 'Cancel' here
            customClass: {
                // Add the custom CSS class to the Swal dialog
                popup: 'swal2-popup',
                actions: 'swal2-actions'
            }
        }).then(function (result) {
            if (result.isConfirmed) {
                let data = {
                    status: item.status.toLowerCase() === 'active' ? 'inactive' : 'active',
                }
                fetch(api.remove_user + `/${item.user_id}`, {
                    method: "DELETE",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                    body: JSON.stringify(data)
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            getAdminList();
                            swal(translate(props.lang, "Success"), responseJson.message, "success");
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            } else {
                                swal(translate(props.lang, "Error"), responseJson.message, "error");
                            }
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });
            }
        });
    }

    const getAdminList = (page = pageNumber) => {
        setLoading(true);
        let url = api.get_admin + `?page=${page}`;
        if (productPerpage) {
            url = url + `&limit=${productPerpage}`
        }
        if (username) {
            url = url + `&username=${username}`
        }
        if (status) {
            url = url + `&status=${status}`
        }
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                if (responseJson.status === "success") {
                    setResult(responseJson.data.results);
                    var pageCount = Math.ceil(responseJson.data.total_results / productPerpage);
                    setPageCount(pageCount);
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log(translate(props.lang, "Error"), responseJson.message, "error");
                }

            }).catch(error => {
                console.error("error", error);
            });
    }

    const edit = (data) => {
        history.push('/system/admin/edit/' + data.user_id)
    }

    const createNewAdmin = () => {
        history.push('/system/admin/new')
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="tableContainer">
                                <Row className="mt-3">
                                    <>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="groupLabel-input">
                                                <div className="input-group">
                                                    <Input
                                                        type="text"
                                                        placeholder={translate(props.lang, "Enter Username")}
                                                        className="form-control input-transparent py-1 px-3"
                                                        onChange={e => setUsername(e.target.value)}
                                                        value={username}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="input-group-select select-placeholder-center">
                                                <Select
                                                    options={
                                                        statusList.length > 0 ? statusList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Status")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    value={statusList.filter(item => item.value === status).map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) }))}
                                                    name="status"
                                                    isClearable={true}
                                                    isSearchable={false}
                                                    onChange={(e) => setStatus(e ? e.value : '')}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="input-group-select select-placeholder-center">
                                                <Select
                                                    options={
                                                        shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Result Per Page")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    isSearchable={false}
                                                    value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                    name="productPerpage"
                                                    onChange={(e) => setProductPerPage(e.value ? e.value : '')}
                                                />
                                            </div>
                                        </Col>
                                    </>

                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => createNewAdmin()}>
                                            <span className={`btnText`}>{translate(props.lang, "Add Admin")}</span>
                                        </button>
                                    </Col>
                                </Row>

                            </div>
                            <>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Login Username")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Role")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={3}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.username}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.user_permission ? item.user_permission : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-white text-start`}>
                                                            {item.status.toLowerCase() === "active" ? (
                                                                <button className="deleteBtn py-2 text-center mx-auto px-4" onClick={() => switchStatus(item)}>
                                                                    <span className={`btnText`}>{translate(props.lang, "Deactivate")}</span>
                                                                </button>
                                                            ) : null}
                                                            <button className="primary-btn py-2 text-center mx-auto px-4 ms-2" onClick={() => edit(item)}>
                                                                <span className={`btnText`}>{translate(props.lang, "Edit")}</span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={3}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                                <div className="pt-4">
                                    {!loading && result.length > 0 ? (
                                        <div className="my-3">
                                            <ReactPaginate
                                                previousLabel={"<"}
                                                nextLabel={">"}
                                                pageCount={pageCount}
                                                forcePage={pageNumber - 1}
                                                onPageChange={changePage}
                                                containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                                previousLinkClassName={"pagination__previouslink pagination-arrow"}
                                                nextLinkClassName={"pagination__nextlink pagination-arrow"}
                                                disabledClassName={"pagination__link--disabled text-muted"}
                                                activeClassName={"pagination__link--active text-black"}
                                                marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(AdminList);